<script lang="ts" setup>
const model = defineModel<any>();

withDefaults(
  defineProps<{
    label?: string;
    inlineLabel?: string;
    items?: any[];
    itemTitle?: string;
    itemValue?: string;
    rules?: any[];
    placeholder?: string;
    type?: string;
    hideDetails?: boolean | 'auto';
    width?: string | number;
    prependInnerIcon?: string;
    requiredMark?: boolean;
    multiple?: boolean;
    chips?: boolean;
    closeableChips?: boolean;
    readonly?: boolean;
    noFilter?: boolean;
    loading?: boolean;
    tooltip?: string;
    clearable?: boolean;
  }>(),
  {
    hideDetails: 'auto',
  },
);

const emit = defineEmits(['update:search']);

function emitSearch(value: string) {
  emit('update:search', value);
}
</script>

<template>
  <div
    :style="{ width }"
    :data-suge-field="label || inlineLabel || undefined"
    :data-suge-required="requiredMark || undefined"
  >
    <m-input-label
      :text="label"
      :required-mark="requiredMark"
      :tooltip="tooltip"
    />

    <v-autocomplete
      :items="items"
      v-model="model"
      variant="outlined"
      compact
      :multiple="multiple"
      :chips="chips"
      :item-title="itemTitle"
      :item-value="itemValue"
      :rules="rules"
      :type="type"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      :label="inlineLabel"
      :width="width"
      :prepend-inner-icon="prependInnerIcon"
      validate-on="blur"
      :readonly="readonly"
      :no-filter="noFilter"
      @update:search="emitSearch"
      :closable-chips="closeableChips"
      :loading="loading"
      :clearable="clearable"
    />
  </div>
</template>
